import { createTheme, Theme } from '@mui/material/styles';

// Color palette - AIONA Corporate Colors
const palette = {
  primary: {
    main: '#003c68',      // 濃紺 - コーポレートカラー
    light: '#1a5a8c',     // 少し明るい濃紺
    dark: '#00284d',      // 更に濃い紺
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#4a9eff',      // アクセントカラー（補色系の明るい青）
    light: '#7cb8ff',
    dark: '#2d7ad9',
    contrastText: '#ffffff',
  },
  success: {
    main: '#4caf50',
    light: '#6fbf73',
    dark: '#357a38',
  },
  warning: {
    main: '#ff9800',
    light: '#ffb333',
    dark: '#b26a00',
  },
  error: {
    main: '#f44336',
    light: '#f6685e',
    dark: '#aa2e25',
  },
  info: {
    main: '#2196f3',
    light: '#4dabf5',
    dark: '#1769aa',
  },
};

// Typography
const typography = {
  fontFamily: [
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(','),
  h1: {
    fontSize: '2.5rem',
    fontWeight: 500,
  },
  h2: {
    fontSize: '2rem',
    fontWeight: 500,
  },
  h3: {
    fontSize: '1.75rem',
    fontWeight: 500,
  },
  h4: {
    fontSize: '1.5rem',
    fontWeight: 500,
  },
  h5: {
    fontSize: '1.25rem',
    fontWeight: 500,
  },
  h6: {
    fontSize: '1rem',
    fontWeight: 500,
  },
};

// Theme creator
export const getTheme = (mode: 'light' | 'dark'): Theme => {
  return createTheme({
    palette: {
      mode,
      ...palette,
      background: {
        default: mode === 'light' ? '#f5f5f5' : '#121212',
        paper: mode === 'light' ? '#fff' : '#1e1e1e',
      },
    },
    typography,
    shape: {
      borderRadius: 8,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
          },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            backgroundImage: 'none',
          },
        },
      },
    },
  });
};
